import type { Context } from 'react';
import { createContext, useContext } from 'react';

export const ScrollableContext: Context<HTMLElement | null> = createContext<HTMLElement | null>(null);

export const useScrollableContext = (): HTMLElement | null => useContext(ScrollableContext);
